import type {
  Plant,
  Line,
  Station,
  Machine,
  Person,
  Product,
  Defect,
  InventoryRow,
} from './types';
import type { WorkOrderRow } from './workOrderGenerator';
import type { AlertRow } from './alarmGenerator';
import type { MESEventRow } from './eventGenerator';
import type { TelemetryStore } from './telemetryGenerator';

export interface Registry {
  plants: Plant[];
  lines: Line[];
  stations: Station[];
  machines: Machine[];
  people: Person[];
  products: Product[];
  workOrders: WorkOrderRow[];
  defects: Defect[];
  alerts: AlertRow[];
  events: MESEventRow[];
  inventory: InventoryRow[];
  telemetry: TelemetryStore;
  initialized: boolean;
  seed: number;
}

export const registry: Registry = {
  plants: [],
  lines: [],
  stations: [],
  machines: [],
  people: [],
  products: [],
  workOrders: [],
  defects: [],
  alerts: [],
  events: [],
  inventory: [],
  telemetry: {},
  initialized: false,
  seed: 0,
};
